import React from 'react';
import { MOCK_USERS } from '../__mocks__/mockUsers';

interface UsersContextType {
  allUsers: UserManagement.User[];
  staffUsers: UserManagement.FleetOpsStaffUser[];
  // Non deleted, signed up and pending users for this customer
  signedUpAndPendingUsers: (
    | UserManagement.SignedUpUser
    | UserManagement.PendingUser
  )[];
  isLoading: boolean;
}

const UsersContext = React.createContext<UsersContextType>({
  allUsers: process.env.NODE_ENV === 'test' ? MOCK_USERS : [],
  staffUsers: [],
  signedUpAndPendingUsers: [],
  isLoading: true,
});

export default UsersContext;
